import React, { useState, useRef, useEffect } from "react";
import { Formik, Field } from "formik";
import Form from "../components/Form";
import { DropDown } from "../../../ui/DropDown";
import { SCORECARD_URL, STRATEGYMAP_URL } from "../../../api/urls";
import { GetHook, postEndpoint } from "../../../api/api";
import Axios from "axios";
import { get } from "../../../utils/get";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

interface IProps {
  closeModal?: any;
  setHandleSubmit?: any;
  perspectiveOptions?: any;
  scorecard_id?: any;
  primaryObjective?: any;
}

const AddLinkageForm = ({
  closeModal,
  setHandleSubmit,
  perspectiveOptions,
  scorecard_id,
  primaryObjective,
}: IProps) => {
  const [parsedObjectives, setParsedObjectives] = useState([]);
  const [postRes, postLinkage] = postEndpoint();
  const formRef: any = useRef<any>(null);
  const params = useParams();
  const handleSubmit = () => {
    if (formRef.current) {
      formRef.current.handleSubmit();
    }
  };

  useEffect(() => {
    setHandleSubmit(() => handleSubmit);
    return () => {};
  }, []);

  useEffect(() => {
    const { complete, pending, data, error } = postRes;
    if (error) {
      toast.error(get(data, "message"));
    }
    if (!pending && complete && !error) {
      closeModal();
      toast.success("Objective linked successfully");
    }

    return () => {};
  }, [postRes]);

  const AddLinkage = (values) => {
    const payload = {
      linked_objective_id: get(values, "objective.value"),
      primary_objective_id: primaryObjective,
    };

    postLinkage(
      `${STRATEGYMAP_URL}/${get(params, "strategymapId")}/objective`,
      payload
    );
  };
  return (
    <Formik
      innerRef={formRef}
      initialValues={{ perspective: "", objective: "" }}
      onSubmit={(values) => AddLinkage(values)}
    >
      {({ values, handleChange, setFieldValue }) => (
        <Form>
          <Field
            name="perspective"
            dropdownLabel="Perspective"
            component={DropDown}
            options={perspectiveOptions}
            width="90%"
            onChange={(values) => {
              setFieldValue("perspective", get(values, "perspective"));
              Axios.get(
                `${SCORECARD_URL}/${scorecard_id}/objective?perspective_id=${get(
                  values,
                  "value"
                )}`
              ).then((res) => {
                const { returned_resultset } = get(res, "data");
                setParsedObjectives(
                  returned_resultset.map((item) => ({
                    label: get(item, "objective_name"),
                    value: get(item, "objective_id"),
                  }))
                );
              });
            }}
            isBordered={true}
            value={get(values, "perspective")}
          />
          <Field
            name="objective"
            dropdownLabel="Objective"
            component={DropDown}
            options={parsedObjectives}
            width="90%"
            isBordered={true}
          />
        </Form>
      )}
    </Formik>
  );
};

export default AddLinkageForm;
